import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Grid } from "../../core/components/grid";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { DatePicker } from "../../core/components/datePicker";
import { IsSearchField } from "../../core/components/isSearchField";
import { FlagContext, FlagEntity } from "./editFlag";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { Config } from "../../core/config/config";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { BaseComponentProps, BaseField } from "../../core/components/baseComponentProps";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class FlagResourcesGrid extends React.Component<FlagResourcesGridProps, FlagResourcesGridState>{
    private factory = ComponentHelper.createFactory();
    private buttons: Array<GridCustomToolBarButton> = [];
    private dialogRef: AddResourcesDialog;
    constructor(props) {
        super(props)
        this.state = {
            day: new Date(),
            gridData: []
        }
        this.initApp();
    }

    private initApp = () => {
        if (this.props.entity.RecordRight.AddResources) {
            this.buttons = [
                {
                    autoEnabledOnRecordSelected: false,
                    caption: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.EditResources"),
                    enabled: true,
                    iconClass: "fal fa-users",
                    id: "addResources"
                }
            ];
        }
        this.loadRessources()
    }

    private loadRessources = async () => {
        const result = await HTTPService.noBusyIndicator().post<JsonResultClass<any[]>>("PlanningBoardFlag/GetRessourcesByFlagId", {
            FlagId: this.props.entity.Id,
            From: this.state.day
        });
        if (result.Code == 0)
            this.setState({ gridData: result.Data })
    }

    private renderDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.day;
        props.onChange = (_, value) => {
            if (Helper.isNullOrEmpty(Helper.dates.toString(value)))
                value = this.state.day;
            this.setState({ day: value }, this.loadRessources)
        }
        return (
            <FieldInstance label={this.props.context.translations["Beleg.Tag"]}>
                <DatePicker {...props}/>
            </FieldInstance>
        ); 
    }

    private renderGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.props.field.gridOptions}
                    id="flagResourcesGrid"
                    customButtons={this.buttons}
                    onClickCustomButton={this.handleCustomButtonClick}
                />
            </div>
        );
    }

    private handleCustomButtonClick = (id: string) => {
        switch (id) {
            case "addResources":
                const data: RessourceInfo[] = this.state.gridData.map((res) => {
                    return {
                        ressnr: res.RessNr,
                        name: res.Resource
                    };
                })
                this.dialogRef.openDialog(this.state.day, data);
                break;
        }
    }

    private setRef = (ref) => {
        this.dialogRef = ref;
    }

    private renderDialog = () => {
        const props: AddResourcesDialogProps = {
            onOK: this.loadRessources,
            translations: this.props.context.translations,
            flagId: this.props.entity.Id
        };
        return (
            <>
                <AddResourcesDialog {...props} ref={this.setRef} />
            </>
        );
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {this.renderDatePicker()}
                {this.renderGrid()}
                {this.renderDialog()}
            </div>
        );
    }
}

interface FlagResourcesGridProps extends BaseComponentProps {
    entity: FlagEntity;
    context: FlagContext;
    field: FlagResourceGridField;
}

interface FlagResourceGridField extends BaseField {
    gridOptions: kendo.ui.GridOptions;
}

interface FlagResourcesGridState {
    day: Date;
    gridData: any[];
}

class AddResourcesDialog extends React.Component<AddResourcesDialogProps, AddResourcesDialogState>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.EditResources"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ dialogOpen: false })

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    
                },
                primary: true
            }
        ],
        width: 500
    };

    constructor(props) {
        super(props)
        this.state = {
            dialogOpen: false,
            data: [],
            day: new Date()
        }
        this.initApp();
    }

    private initApp = () => {
        this.dialogProps.actions[1].action = this.onOk;
    }

    private onOk = () => {
        //Funktion darf nicht async sein
        HTTPService.post<JsonResultClass>("PlanningBoardFlag/AddResourcesToFlag", {
            ressNrs: this.state.data.map((item) => { return item.ressnr }),
            flagId: this.props.flagId,
            day: this.state.day
        }).then((result) => {
            if (result.Code == 0) {
                this.setState({ dialogOpen: false }, this.props.onOK)
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        })
    }

    openDialog = (day: Date, data: RessourceInfo[] = []) => {
        this.setState({ dialogOpen: true, day: day, data: data })
    }

    private renderDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.renderSearch()}
                    {this.renderDatePicker()}
                </Dialog>
            </>
        );
    }

    private renderSearch = () => {
        const props = this.factory.getDefaultSearchFieldProps();
        props.multiSelectMode = true;
        props.value = this.state.data;
        props.field.dataTextField = "name";
        props.field.dataValueField = "ressnr";
        props.field.searchTextField = "name";
        props.field.searchValueField = "ressnr";
        props.field.searchWindowUrl = "DynamicSearch/Window/resource?multi=true&resstatus=0%20or%20null&disabled=resstatus&displayPattern=[[name]]&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true";
        props.onChange = (_, __, data) => { this.setState({ data: data }) }
        props.onOpened = () => { this.setState({ dialogOpen: false }) }
        props.onClose = () => { this.setState({ dialogOpen: true }) };
        return (
            <FieldInstance label={this.props.translations["Ressource.Ressourcen"]}>
                <IsSearchField {...props} />
            </FieldInstance>
        );
    }

    private renderDatePicker = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.value = this.state.day;
        props.onChange = (_ , value) => {
            if (Helper.isNullOrEmpty(Helper.dates.toString(value)))
                value = this.state.day;
            this.setState({ day: Helper.dates.toDate(value) })
        }

        return (
            <FieldInstance label={this.props.translations["Beleg.Tag"]}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    render() {
        return this.state.dialogOpen ? this.renderDialog(): null;
    }
}

interface AddResourcesDialogProps {
    onOK: () => void;
    translations: StringKeyDictionary<string>;
    flagId: string;
}

interface AddResourcesDialogState {
    dialogOpen: boolean;
    data: RessourceInfo[];
    day: Date;
}

interface RessourceInfo {
    ressnr: string,
    name: string
}